import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { LEGAL_CARGO_PATH, LEGAL_MANIFEST_BAGGAGE_PATH, LEGAL_MANIFEST_CARGO_PATH, LEGAL_MANIFEST_TICKET_PATH, LEGAL_TICKET_PATH, LEGAL_UNIT_PATH } from '../../../config/paths';
import LegalHome from './LegalHome';
import LegalCargos from './legal-cargo/LegalCargos';
import LegalTicket from './legal-cargo/LegalTicket';
import LegalManifestCargos from './legal-cargo/LegalManifestCargos';
import LegalManifestTickets from './LegalManifestTickets';
import LegalManifestBaggages from './legal-manifest-baggage/LegalManifestBaggages';

const LegalManagementModule = () => (
  <Switch>
    <Route exact path={LEGAL_UNIT_PATH} component={LegalHome} />
    <Route path={LEGAL_CARGO_PATH} component={LegalCargos} />
    <Route path={LEGAL_TICKET_PATH} component={LegalTicket} />
    <Route path={LEGAL_MANIFEST_CARGO_PATH} component={LegalManifestCargos} />
    <Route path={LEGAL_MANIFEST_TICKET_PATH} component={LegalManifestTickets} />
    <Route path={LEGAL_MANIFEST_BAGGAGE_PATH} component={LegalManifestBaggages} />
  </Switch>
);

export default LegalManagementModule;
